import { useTranslate } from "src/i18n";

export const useUserDataTranslate = () => {
  const { t } = useTranslate();

  return {
    title: t("profile.user_data.title", "Персональная информация"),
    fullNameNull: t("profile.user_data.fullNameNull", "Нет информации"),
    email: {
      confirm: t("profile.user_data.email.confirm", "Подтвержден"),
      unconfirm: t("profile.user_data.email.confirm", "Ожидает подтверждения"),
    },
    balance: t("profile.user_data.balance", "Баланс"),
    userFields: {
      name: t("profile.user_data.user_fields.name", "Имя пользователя"),
      email: t("profile.user_data.user_fields.email", "Почта"),
      fullName: t("profile.user_data.user_fields.fullName", "ФИО"),
      phone: t("profile.user_data.user_fields.phone", "Номер телефона"),
      role: t("profile.user_data.user_fields.role", "Роль"),
      accountCreate: t(
        "profile.user_data.user_fields.accountCreate",
        "Аккаунт создан",
      ),
      social: t("profile.user_data.user_fields.social", "Социальные сети"),
    },
  };
};
